import React, { FC, Fragment } from "react";
import MainSection from "../../MainSection";
import { NavMenuProps } from "../../NavMenu";
import RightSection from "../../RightSection";
import Logo from "../Logo";

const DesktopOnlyView: FC<NavMenuProps> = ({ moduleIds, hideLogin }) => (
  <Fragment>
    <Logo />
    <MainSection moduleIds={moduleIds} />
    <RightSection hideLogin={hideLogin} />
  </Fragment>
);

export default DesktopOnlyView;
